import React from 'react';
import { connect } from 'react-redux';
import { Button, Card, ListGroup, Modal, Form, Alert } from 'react-bootstrap';
import { changePassword } from '../../actions';
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';

class MyAccount extends React.Component {
  state = {
    showChangePasswordModal: false,
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    error: null,
    success: false
  };

  handleLogout = () => {
    localStorage.removeItem('eit_token');
    window.location.reload();
  };

  handleShowChangePasswordModal = () => {
    this.setState({
      showChangePasswordModal: true,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: null,
      success: false
    });
  };

  handleCloseChangePasswordModal = () => {
    this.setState({
      showChangePasswordModal: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: null,
      success: false
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleChangePassword = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = this.state;

    // Validate passwords
    if (newPassword !== confirmPassword) {
      this.setState({ error: 'New passwords do not match' });
      return;
    }

    if (newPassword.length < 6) {
      this.setState({ error: 'New password must be at least 6 characters long' });
      return;
    }

    try {
      const success = await this.props.changePassword(newPassword, currentPassword);
      
      if (success) {
        this.setState({ 
          success: true,
          error: null,
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        });
        // Close modal after 2 seconds
        setTimeout(() => {
          this.handleCloseChangePasswordModal();
        }, 2000);
      } else {
        this.setState({ error: 'Failed to change password. Please check your current password.' });
      }
    } catch (err) {
      this.setState({ error: err.message || 'Failed to change password' });
    }
  };

  render() {
    const { user } = this.props;
    const { 
      showChangePasswordModal, 
      currentPassword, 
      newPassword, 
      confirmPassword, 
      error, 
      success 
    } = this.state;

    if (!user) return <div>{getTranslate(LANGUAGE_KEYS.TEXT_LOADING)}</div>;
    return (
      <>
        <Card style={{ maxWidth: 500, margin: '40px auto' }}>
          <Card.Header as="h4">{getTranslate(LANGUAGE_KEYS.TEXT_MY_ACCOUNT)}</Card.Header>
          <Card.Body>
            <ListGroup variant="flush">
              <ListGroup.Item><b>{getTranslate(LANGUAGE_KEYS.TEXT_USERNAME)}:</b> {user.username}</ListGroup.Item>
              <ListGroup.Item><b>{getTranslate(LANGUAGE_KEYS.TEXT_FULL_NAME)}:</b> {user.full_name}</ListGroup.Item>
              <ListGroup.Item><b>{getTranslate(LANGUAGE_KEYS.TEXT_STATUS)}:</b> {user.status ? getTranslate(LANGUAGE_KEYS.TEXT_ACTIVE) : getTranslate(LANGUAGE_KEYS.TEXT_INACTIVE)}</ListGroup.Item>
              <ListGroup.Item><b>{getTranslate(LANGUAGE_KEYS.TEXT_CREATED_AT)}:</b> {user.createdAt && new Date(user.createdAt).toLocaleString()}</ListGroup.Item>
              <ListGroup.Item><b>{getTranslate(LANGUAGE_KEYS.TEXT_UPDATED_AT)}:</b> {user.updatedAt && new Date(user.updatedAt).toLocaleString()}</ListGroup.Item>
              <ListGroup.Item><b>{getTranslate(LANGUAGE_KEYS.TEXT_GROUPS)}:</b> {(user.groups || []).join(', ')}</ListGroup.Item>
            </ListGroup>
            <div className="text-center mt-4">
              <Button variant="primary" className="me-2" onClick={this.handleShowChangePasswordModal}>
                {getTranslate(LANGUAGE_KEYS.TEXT_CHANGE_PASSWORD)}
              </Button>
              <Button variant="danger" onClick={this.handleLogout}>{getTranslate(LANGUAGE_KEYS.TEXT_LOGOUT)}</Button>
            </div>
          </Card.Body>
        </Card>

        <Modal show={showChangePasswordModal} onHide={this.handleCloseChangePasswordModal}>
          <Modal.Header closeButton>
            <Modal.Title>{getTranslate(LANGUAGE_KEYS.TEXT_CHANGE_PASSWORD)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{getTranslate(LANGUAGE_KEYS.TEXT_PASSWORD_CHANGED_SUCCESS)}</Alert>}
            <Form onSubmit={this.handleChangePassword}>
              <Form.Group className="mb-3">
                <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CURRENT_PASSWORD)}</Form.Label>
                <Form.Control
                  type="password"
                  name="currentPassword"
                  value={currentPassword}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_NEW_PASSWORD)}</Form.Label>
                <Form.Control
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CONFIRM_NEW_PASSWORD)}</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="w-100">
                {getTranslate(LANGUAGE_KEYS.TEXT_CHANGE_PASSWORD)}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authenReducer.user
});

export default connect(mapStateToProps, { changePassword })(MyAccount); 